/* eslint-disable prefer-destructuring */

/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function item(theme, ownerState) {
  const { palette, borders, functions, transitions } = theme;
  const { active, color, transparentSidenav, whiteSidenav, darkMode } = ownerState;

  const { transparent, white, grey, dark } = palette;
  const { borderRadius } = borders;
  const { rgba } = functions;

  return {
    pl: 3,
    mt: 0,
    mb: 0,
    width: "100%",
    borderRadius: "6px",
    cursor: "pointer",
    backgroundColor: () => {
      let backgroundValue = transparent.main;

      if (active) {
        if (darkMode) {
          backgroundValue = rgba(white.main, 0.1);
        } else {
          backgroundValue = rgba(dark.main, 0.08);
        }
      }

      return backgroundValue;
    },
    boxShadow: "none",
    border: "none",
    transition: transitions.create(["background-color"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.sharp,
    }),

    "&:hover, &:focus": {
      backgroundColor: !active ? (darkMode ? rgba(white.main, 0.05) : rgba(dark.main, 0.04)) : undefined,
    },
  };
}

function itemContent(theme, ownerState) {
  const { palette, typography, transitions, functions } = theme;
  const { miniSidenav, name, active, transparentSidenav, whiteSidenav, darkMode, icon } = ownerState;

  const { white, dark } = palette;
  const { size, fontWeightRegular, fontWeightLight } = typography;
  const { pxToRem } = functions;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: miniSidenav ? "center" : "space-between",
    width: "100%",
    padding: `${pxToRem(4)} ${pxToRem(12)}`,
    marginLeft: miniSidenav ? 0 : pxToRem(16),
    userSelect: "none",
    position: "relative",
    minHeight: "32px",

    "& span": {
      color: ((transparentSidenav || whiteSidenav) && !darkMode) ? dark.main : white.main,
      fontWeight: active ? fontWeightRegular : fontWeightLight,
      fontSize: size.xs,
      opacity: 1,
      transition: transitions.create(["opacity", "color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .icon-wrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: miniSidenav ? "static" : "absolute",
      top: miniSidenav ? "auto" : "50%",
      transform: miniSidenav ? "none" : "translateY(-50%)",
      left: miniSidenav ? "auto" : pxToRem(-15),
      opacity: 1,
      fontSize: size.sm,
      color: ((transparentSidenav || whiteSidenav) && !darkMode) ? dark.main : white.main,

      "&::before": {
        content: '""',
      },
    },

    "& .MuiTypography-root": {
      display: miniSidenav ? "none" : "inline",
      color: ((transparentSidenav || whiteSidenav) && !darkMode) ? dark.main : white.main,
      fontWeight: active ? fontWeightRegular : fontWeightLight,
      fontSize: size.sm,
      opacity: 1,
      transition: transitions.create(["opacity", "color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    }
  };
}

function itemArrow(theme, ownerState) {
  const { palette, typography, transitions, breakpoints, functions } = theme;
  const { noCollapse, transparentSidenav, whiteSidenav, miniSidenav, open, active, darkMode } =
    ownerState;

  const { white, dark } = palette;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.lg} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? "rotate(0)" : "rotate(-180deg)",
    color: () => {
      let colorValue;

      if (transparentSidenav && darkMode) {
        colorValue = open || active ? white.main : rgba(white.main, 0.45);
      } else if ((transparentSidenav || whiteSidenav) && !darkMode) {
        colorValue = open || active ? dark.main : rgba(dark.main, 0.45);
      } else {
        colorValue = open || active ? white.main : rgba(white.main, 0.5);
      }

      return colorValue;
    },
    transition: transitions.create(["color", "transform", "opacity"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      display:
        noCollapse || (transparentSidenav && miniSidenav) || miniSidenav
          ? "none !important"
          : "block !important",
    },
  };
}

export { item, itemArrow, itemContent };

